import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState, { ITextTemplateItem } from '../../store/state'
import { Prop, Watch } from 'vue-property-decorator'
import { debouncedSaveArticle } from '../../utils/utils'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class TextTemplate extends Vue {
  @Prop({default: false})
  isEditing: boolean
  
  @Prop({default: null})
  textIndex: number

  @Prop({default: ''})
  text: string
  @Prop({default: ''})
  color: string
  @Prop({default: ''})
  opacity: string
  @Prop({default: ''})
  strokeColor: string
  @Prop({default: ''})
  fontFamily: string
  @Prop({default: ''})
  backgroundColor: string
  @Prop({default: ''})
  fontSize: string

  @Prop({default: null})
  textTemplateId: string

  @Prop({default: 0})
  x: number

  @Prop({default: 0})
  y: number

  @Prop({default: 0})
  scale: number

  @Prop({default: 0})
  width: number

  @Prop({default: 0})
  height: number

  @Prop({default: true})
  editable: boolean

  @Watch('isEditing')
  listenIsEditing(val) {
    console.log('isEditing', val)
  }

  state = new PageState()

  created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
  }
  get _fontFamily() {
    console.log('_fontFamily', this.fontFamily)
    return this.fontFamily
  }

  mounted() {
    // 播放器容器宽高
    const container = document.getElementById('textTemplateContainer') as HTMLElement
    if (container) {
      this.containerWidth = container.clientWidth
      this.containerHeight = container.clientHeight
    }
    // 预览容器宽高
    const previewContainer = document.getElementById('previewTextTemplateContainer') as HTMLElement
    if (previewContainer) {
      this.previewContainerWidth = previewContainer.clientWidth
      this.previewContainerHeight = previewContainer.clientHeight
    }
  }

	/****************************** 文字模板 ******************************/

	// 当前的文字模板
	get operatingTextTemplateItem() {
		const textTemplate: ITextTemplateItem = this.state.defaultTextTemplateList.find(item => {
			return item.id === this.textTemplateId
		})
    console.log('operatingTextTemplateItem', textTemplate)
		return textTemplate || {}
	}

  get textTemplateTextList() {
    return this.text.split('')
  }

  get gridTemplateColumns() {
    switch(this.operatingTextTemplateItem.direction) {
      case 'row':
        return {
          'display': 'flex',
          'flex-direction': this.operatingTextTemplateItem.direction
        }
      case 'column':
        return {
          'display': 'flex',
          'flex-direction': this.operatingTextTemplateItem.direction
        }
      case 'table':
        return {
          'display': 'grid',
          'grid-template-columns': `repeat(${ this.operatingTextTemplateItem.column }, 1fr)`,
          'grid-template-rows': `repeat(${ this.operatingTextTemplateItem.maxLength / (this.operatingTextTemplateItem.column || 1) }, 1fr)`
        }
      default:
        return 'repeat(1, 1fr)'
    }
  }

  /** 选择文字模板 */
  handleSelectTextTemplate() {
    if (!this.$props.editable) return
    this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, true)
    this.$bus.$emit(this.$EventBusKey.EDIT_TEXT_TEMPLATE, this.textIndex)
  }

	/****************************** 拖拽模板 ******************************/

  // 移动是/否开始
  isTouchStarted = false
  // X/Y 轴起始点
  startX = 0
  startY = 0
  // 起始 left/top 距离
  startOffsetLeft = 0
  startOffsetTop = 0
  // 文字模板宽/高
  textTemplateWidth = 0
  textTemplateHeight = 0
  // 视频播放容器宽/高
  containerWidth = 0
  containerHeight = 0
  // 预览视频播放容器宽/高
  previewContainerWidth = 0
  previewContainerHeight = 0

  get textContentWidth() {
    switch(this.$props.parent) {
      case 'player':
        return this.$props.width
      case 'screen_player':
        return this.previewContainerWidth ? this.previewContainerWidth * (this.$props.width / this.containerWidth) : 0
      default:
        return this.$props.width
    }
  }

  get textContentHeight() {
    switch(this.$props.parent) {
      case 'player':
        return this.$props.height
      case 'screen_player':
        return this.previewContainerHeight ? this.previewContainerHeight * (this.$props.height / this.containerHeight) : 0
      default:
        return this.$props.height
    }
  }

  handleTouchStart(event) {
    console.log('handleTouchStart', event)
    if (!this.$props.editable) return
    if (!this.isEditing) return
    // 设置起始的 X Y 轴位置
    const touchInfo = event.targetTouches[0]
    this.startX = touchInfo.pageX
    this.startY = touchInfo.pageY
    // 设置起始的 offsetLeft offsetTop 值
    // 设置正在移动状态
    this.isTouchStarted = true
    // 处理边界问题
    const textTemplate = document.getElementById(`textTemplate${ this.textIndex }`) as HTMLElement
    this.textTemplateWidth = textTemplate.clientWidth
    this.textTemplateHeight = textTemplate.clientHeight
    this.startOffsetLeft = textTemplate.offsetLeft
    this.startOffsetTop = textTemplate.offsetTop
  }

  handleTouchMove(event) {
    if (!this.$props.editable) return
    if (this.isTouchStarted) {
      const touchInfo = event.targetTouches[0]
      const translateX = touchInfo.pageX - this.startX
      const translateY = touchInfo.pageY - this.startY
      this.state.operatingTextContent.x = this.state.savedTextContent.x + (translateX / this.containerWidth)
      this.state.operatingTextContent.y = this.state.savedTextContent.y + (translateY / this.containerHeight)
      // 存入数组
      this.updateOperatingTextList()
    }
  }

  async handleTouchEnd() {
    if (!this.$props.editable) return
    if (this.isTouchStarted) {
      this.state.savedTextContent.x = this.state.operatingTextContent.x
      this.state.savedTextContent.y = this.state.operatingTextContent.y
      // 保存
      this.saveOperatingTextList()
      // 取消正在移动状态
      this.isTouchStarted = false
      // 保存文章
      debouncedSaveArticle(this, true)
    }
  }

	/****************************** 缩放模板 ******************************/

  // 移动是/否开始
  isScaleTouchStarted = false
  // 缩放起始点 X/Y 轴
  scaleStartX = 0
  scaleStartY = 0

  handleScaleTouchStart(event) {
    if (!this.$props.editable) return
    if (!this.isEditing) return
    if (!this.operatingTextTemplateItem.id && !this.text) return
    if (this.state.operatingTextContent.text && !this.state.operatingTextContent.id) {
      const idRef = `textTemplateRef_${this.state.operatingTextIndex}`
      const textTemplate = this.$refs[idRef] as HTMLElement
      this.state.operatingTextContent.width = textTemplate.clientWidth / 2
      this.state.operatingTextContent.height = textTemplate.clientHeight / 2
    }
    // 设置起始的 X Y 轴位置
    const touchInfo = event.targetTouches[0]
    this.scaleStartX = touchInfo.pageX
    this.scaleStartY = touchInfo.pageY
    // 设置正在移动状态
    this.isScaleTouchStarted = true
    // 播放器容器宽高
    const container = document.getElementById('videoImgCanvas') as HTMLCanvasElement
    this.containerWidth = container.clientWidth
    this.containerHeight = container.clientHeight
    // 处理边界问题
    const textTemplate = document.getElementById(`textTemplate${ this.textIndex }`) as HTMLElement
    this.startOffsetLeft = textTemplate.offsetLeft
    this.startOffsetTop = textTemplate.offsetTop
  }

  handleScaleTouchMove(event) {
    if (!this.$props.editable) return
    if (!this.operatingTextTemplateItem.id && !this.text) return
    if (this.isScaleTouchStarted) {
      const touchInfo = event.targetTouches[0]
      const translateX = touchInfo.pageX - this.scaleStartX
      const translateY = touchInfo.pageY - this.scaleStartY
      // 文字模板宽高
      const textTemplateWidth = this.state.operatingTextContent.width
      const textTemplateHeight = this.state.operatingTextContent.height
      // 
      // console.log(this.state.savedTextContent.scale, translateX, textTemplateWidth)
      // 缩放
      this.state.operatingTextContent.scale = this.state.savedTextContent.scale + (translateX / textTemplateWidth)
      // 存入数组
      this.updateOperatingTextList()
    }
  }

  async handleScaleTouchEnd() {
    if (!this.$props.editable) return
    if (!this.operatingTextTemplateItem.id && !this.text) return
    if (this.isScaleTouchStarted) {
      this.state.savedTextContent.scale = this.state.operatingTextContent.scale
      // 保存
      this.saveOperatingTextList()
      // 取消正在移动状态
      this.isTouchStarted = false
      // 保存文章
      debouncedSaveArticle(this, true)
    }
  }

  /** 更新正在操作的文字列表 */
  updateOperatingTextList() {
    this.state.operatingTextList = this.state.operatingTextList.map((item, index) => {
      return (
        index === this.state.operatingTextIndex 
          ? this.state.operatingTextContent
          : item
      )
    })
  }

  /** 保存文字列表 */
  saveOperatingTextList() {
    // 存储文字模板列表（深拷贝）
    this.state.savedTextList = [...this.state.operatingTextList]
  }

}